// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "td[data-v-7ef2a2c0],\nth[data-v-7ef2a2c0] {\n  vertical-align: middle;\n  white-space: nowrap;\n}\nth[data-v-7ef2a2c0],\ntd[data-v-7ef2a2c0] {\n  white-space: nowrap;\n}\nth[data-v-7ef2a2c0]:last-child,\ntd[data-v-7ef2a2c0]:last-child {\n  position: sticky;\n  right: 0;\n  background: #fff;\n}\nth[data-v-7ef2a2c0]:last-child {\n  z-index: 100;\n}\ntd[data-v-7ef2a2c0]:last-child {\n  z-index: 99;\n}", ""]);
// Exports
module.exports = exports;
